const state = {
    params: null
};
const getters = {
    hashParams: (state) => {
        if(window.location.hash) {
            state.params = window.location.hash.substring(1)
                .split(';')
                .map(h => h.split('='))
                .reduce((acc, [key, val]) => ({
                    ...acc,
                    [key]: val
                }), {});
            if(state.params.additionalCosts){
                state.params.additionalCostsBase64 = state.params.additionalCosts;
                try {
                    state.params.additionalCosts = window.atob(state.params.additionalCosts);
                } catch (err) {
                    console.error('Cannot read additionalCosts');
                    console.error(err);
                }
            }
        }
        return state.params;
    },

    hasHashParams: () => !!window.location.hash
};
const actions = {};
const mutations = {
    clearHashParams: (state) => {
        state.params = null
        window.location.hash = ''
    },
    hashParamsSet: (state, param) => {
        state.params = {
            ...(state.params) ? state.params : {},
            ...param
        };
        window.location.hash = Object.keys(state.params)
            .map(paramName => {
                if(paramName === 'additionalCosts') {
                    return paramName + '=' + window.btoa(state.params[paramName]);
                }
                return paramName + '=' + state.params[paramName];
            })
            .join(';')
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}